<template>
  <Card>
    <h1 slot="Title">GFEBS Assigned Reference Number</h1>
    <div slot="MainContent">
      <p>
        <b>GFEBS Assigned Reference Number (GRN) 1000000067</b>: A system generated and is used to identify and track each expenditure transaction, from the commitment through the disbursement stage. 
      </p>
      <p>
        The GFEBS Assigned Reference Number contains six to fourteen characters and is unique to each transaction.
      </p>
      <p class="mt-12 mb-0">
        202011D20 A76VV 131096QLOG 6100.2617 WBS, Internal Order or Cost Center <b><u>1000000067</u></b> 021001
      </p>
    </div>
    <p><strong>GFEBS Assigned Reference Number</strong></p>
    <p><strong>GFEBS ASSIGNED REFERENCE NUMBER (1000000067).</strong> The sixth element in the line of accounting is the GFEBS Assigned Reference Number.&nbsp; The GFEBS Assigned Reference Number is GFEBS generated. These numbers can be generated by several types of transactions, i.e. Purchase Requisitions and Purchase Orders.</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
    <p><strong>INSTRUCTOR NOTE:&nbsp; Ask students,</strong></p>
    <p><strong>Question:&nbsp; Since we know that the number is assigned by GFEBS can we look up this information?&nbsp; </strong></p>
    <p><strong>Answer:&nbsp; No we cannot because it is assigned by GFEBS. </strong></p>
    <p>When the FMY1 is done, (for now it is only done in a operational environment) it will not generate the GRN because this is a pre-commitment.&nbsp; When the actual obligation is done the GRN will be computer generated.</p>
  </Card>
</template>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'GFEBS Assigned Reference Number',
  
  data() {
    return {
    }
  }
  
}
</script>